import { render, staticRenderFns } from "./NuevosIngresosComponent.vue?vue&type=template&id=65f78dcd&scoped=true"
import script from "./NuevosIngresosComponent.vue?vue&type=script&lang=js"
export * from "./NuevosIngresosComponent.vue?vue&type=script&lang=js"
import style0 from "./NuevosIngresosComponent.vue?vue&type=style&index=0&id=65f78dcd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f78dcd",
  null
  
)

export default component.exports